import React from 'react';
import { Link } from 'react-router-dom';
import logo from './images/mascot.png';

const appHeaderActionClasses =
  'inline-flex cursor-pointer items-center justify-center px-4 py-2 rounded-full border border-white/70 bg-white/75 text-sm font-semibold text-slate-700 shadow-sm transition-colors duration-200 hover:bg-white hover:text-pink-600 disabled:cursor-not-allowed';

const AppHeader = ({ children }) => {
  return (
    <nav className="sticky top-0 z-20 border-b border-white/60 bg-white/80 backdrop-blur-md shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between py-4 gap-4">
          <Link to="/" className="flex items-center gap-3 min-w-0">
            <div className="flex h-11 w-11 items-center justify-center rounded-2xl border border-pink-100 bg-gradient-to-br from-pink-50 to-purple-50 shadow-sm">
              <img src={logo} alt="Fluffball Logo" className="h-8 w-8 object-contain" />
            </div>
            <span className="text-xl font-bold tracking-tight bg-gradient-to-r from-pink-500 to-purple-500 bg-clip-text text-transparent">
              fluffball
            </span>
          </Link>

          <div className="flex items-center gap-2 sm:gap-3">
            {children}
          </div>
        </div>
      </div>
    </nav>
  );
};

export { appHeaderActionClasses };
export default AppHeader;
